import { Badge, Icon, IconButton, Image } from "components";
import { Loading } from "containers";
import { convertDate, sortHashtags, toExtraLink, viewExtraLink } from "helpers";
import { useAxios } from "hooks";
import { Layout } from "layouts";
import Error404 from "pages/Error404";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link, useSearchParams } from "react-router-dom";
import { Magazine } from "types";

export default function ArticleDetails() {
  const navigate = useNavigate();
  const [axios, loading] = useAxios();
  const [searchParams] = useSearchParams();
  const [article, setArticle] = useState<Magazine.ArticleDetails | null>(null);

  const userId = searchParams.get("userId");
  const articleId = searchParams.get("articleId");

  const goBack = () => {
    navigate(-1);
  };
  const getArticle = () => {
    if (!userId || !articleId) return;
    const url = `/People/${userId}/get-public-articles/${articleId}`;
    axios.get(url).then(({ data }) => {
      setArticle(data);
    });
  };
  useEffect(getArticle, [userId, articleId]);
  if (loading) return <Loading />;
  if (!article) return <Error404 />;
  return (
    <Layout>
      <Layout.Header
        className="bg-white"
        divProps={{ className: "flex items-center gap-2" }}
      >
        <IconButton type="button" variant="text" color="dark" onClick={goBack}>
          <Icon name="ArrowLeft2" />
        </IconButton>
        <h6 className="text-center flex-1 text-base font-semibold text-dark">
          Article
        </h6>
        <IconButton type="button" className="invisible">
          <Icon name="ArrowLeft2" />
        </IconButton>
      </Layout.Header>
      <Layout.Body className="space-y-2.5">
        <div className="w-full py-1">
          <Image
            src={article.photo?.url}
            alt={article.title}
            className="w-full aspect-image rounded object-cover"
          />
        </div>
        <div className="space-y-1">
          <h3 className="text-base font-semibold text-dark">{article.title}</h3>
          <p className="text-sm font-medium text-[#9A9EB1] empty:hidden">
            {article.articleCategory?.title?.at(0)?.value}
          </p>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: article.description }}
          className="text-base font-normal text-[#5E6278] whitespace-pre-wrap empty:hidden"
        />
        <div className="flex flex-wrap gap-1 py-1 empty:hidden">
          {sortHashtags(article.hashtag)?.map((e) => (
            <Badge key={e}>#{e}</Badge>
          ))}
        </div>
        {!!article.extraLink && (
          <Link
            target="_blank"
            to={toExtraLink(article.extraLink)}
            className="flex items-center gap-1"
          >
            <Icon name="LinkCircle" className="size-6 text-[#5E6278]" />
            <span className="text-sm text-primary font-medium cursor-pointer underline flex-1 truncate">
              {viewExtraLink(article.extraLink)}
            </span>
          </Link>
        )}
        <p className="text-xs font-medium text-[#9A9EB1] py-1 empty:hidden">
          {convertDate(article.creationTime, "full-date")}
        </p>
      </Layout.Body>
      <Layout.Footer />
    </Layout>
  );
}
